const InstantBookingIcon = ({ height = "20", width = "20" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect
      x="2.4"
      y="3.29819"
      width="15.2"
      height="15.2"
      rx="1.6"
      fill="white"
      stroke="#1F2A37"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.4 4.99341C2.4 4.10975 3.11634 3.39341 4 3.39341H16C16.8837 3.39341 17.6 4.10975 17.6 4.99341V7.59341H2.4V4.99341Z"
      fill="#FDC8D3"
      stroke="#1F2A37"
      strokeWidth="0.8"
    />
    <path d="M7 2V3" stroke="#1F2A37" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 2V3" stroke="#1F2A37" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7 12.98L8.26626 14.178C8.65182 14.5427 9.25516 14.5427 9.64072 14.178L13 11"
      stroke="#1F2A37"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
  </svg>
);
export default InstantBookingIcon;
